import React from 'react'
import PropTypes from 'prop-types'
import {Grid, withStyles} from '@material-ui/core'
import { Loader } from './components';

const styles = {
    container: {
        paddingTop: '5em'
    },

    contentContainer: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap'
    }
}

const defaultGridProps = {
    xl: 8,
    lg: 8,
    md: 10,
    sm: 10,
    xs: 10
}

const PageContainer = function({classes: styles, children, className, gridProps, containerClassName, isLoadingContent, loaderText}) {
    return (
        <Grid
            container
            justify="center"
            direction="row"
            className={`${styles.container} ${containerClassName}`}
        >
            <Grid item {...defaultGridProps} {...gridProps} className={`${styles.contentContainer} ${className}`}>
                {isLoadingContent
                    ? <Loader isLoading={isLoadingContent} loaderText={loaderText} />
                    : children
                }
            </Grid>
        </Grid>
    )
}

PageContainer.propTypes = {
    classes: PropTypes.object,
    className: PropTypes.string,
    gridProps: PropTypes.objectOf(Grid),
    children: PropTypes.any,
    containerClassName: PropTypes.string,
    isLoadingContent: PropTypes.bool,
    loaderText: PropTypes.string
}

PageContainer.defaultProps = {
    gridProps: defaultGridProps,
    isLoadingContent: false
}

export default withStyles(styles)(PageContainer);
